import { createSelector } from 'reselect'

const selectSettings = state => state.settings

export const selectDocumentRequests = createSelector([selectSettings], settings => settings.documentRequests)

export const selectDocumentFormData = createSelector([selectSettings], settings => settings.documentFormData)

export const selectSuccessData = createSelector([selectSettings], settings => settings.successData)

export const selectSuccessMsg = createSelector([selectSettings], settings => settings.success)

export const selectSettingsLoader = createSelector([selectSettings], settings => settings.loader)

export const selectSettingsError = createSelector([selectSettings], settings => settings.error)

export const selectSupportedCurrencies = createSelector([selectSettings], settings => settings.supportedCurrencies)

export const selectSupportedLanguages = createSelector([selectSettings], settings => settings.supportedLanguages)

export const selectSupportDepartmentsConversations = createSelector([selectSettings], settings => settings.supportDepartmentsConversations)

export const selectSupportConversations = createSelector([selectSettings], settings => settings.supportConversations)

export const selectedSupportConversationDetails = createSelector([selectSettings], settings => settings.supportConversationDetails)

export const selectedSupportConversationFile = createSelector([selectSettings], settings => settings.supportConversationFile)

export const selectedSupportUnreadConversations = createSelector([selectSettings], settings => settings.supportUnreadConversations)

export const selectServicePlans = createSelector([selectSettings], settings => settings.servicePlans)

export const selectServiceFeesSchedule = createSelector([selectSettings], settings => settings.serviceFeesSchedule?.groups)

export const selectServiceFeesScheduleNo = createSelector([selectSettings], settings => settings.serviceFeesScheduleNo?.groups)

export const selectNotifications = createSelector([selectSettings], settings => settings.notifications)

export const selectDefaultOperationalCurrency = createSelector([selectSettings], settings => settings.defaultOperationalCurrency)

export const selectFeatures = createSelector([selectSettings], settings => settings.features)

export const selectUserSettings = createSelector([selectSettings], settings => settings.settings)

export const selectCompanyUsers = createSelector([selectSettings], settings => settings.companyUsers)

export const selectCompanyUsersGroup = createSelector([selectSettings], settings => settings.companyUsersGroup)

export const selectDynamicForm = createSelector([selectSettings], settings => settings.dynamicForm)

export const selectFile = createSelector([selectSettings], settings => settings.file)
